import { useEffect, useRef, useState } from 'react';
import { formatDisplayMMSS, formatHMS } from '../../../utils/sopGame';

/**
 * Count-up timer. initialSeconds from DB timee (stages 2+) or 0 (stage 1).
 * Calls onTick(hms, displayMMSS, totalSeconds) every second.
 */
export default function useGameTimer(initialSeconds = 0, onTick) {
  const [elapsed, setElapsed] = useState(() => Math.max(0, Math.floor(initialSeconds) || 0));
  const elapsedRef = useRef(elapsed);
  const onTickRef = useRef(onTick);
  onTickRef.current = onTick;

  useEffect(() => {
    elapsedRef.current = Math.max(0, Math.floor(initialSeconds) || 0);
    setElapsed(elapsedRef.current);
  }, [initialSeconds]);

  useEffect(() => {
    const id = setInterval(() => {
      elapsedRef.current += 1;
      setElapsed(elapsedRef.current);
      const hms = formatHMS(elapsedRef.current);
      const display = formatDisplayMMSS(elapsedRef.current);
      onTickRef.current?.(hms, display, elapsedRef.current);
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return {
    elapsed,
    timee: formatHMS(elapsed),
    display: formatDisplayMMSS(elapsed),
  };
}
